import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {ThorGameMode} from "../gamemode/ThorGameMode";

/**
 * Created by Jerker Nord on 2019-12-16.
 */

export class ThorScatterRespinZeroBetController extends RespinZeroBetController {

    constructor() {
        super();
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        if(data.nextMode == ThorGameMode.SCATTER_RESPIN
            || (data.mode == ThorGameMode.SCATTER_RESPIN && data.nextMode == ThorGameMode.SCATTER_RESPIN)
            || ((<ParsedInitData>data).isRestoreState && data.mode == ThorGameMode.SCATTER_RESPIN && data.nextMode == ThorGameMode.NORMAL)) {
            return true;
        } else {
            return false;
        }
    }
}